import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Button, Card } from "@tenant/ui";
import styles from "./ChangeFlightEligibilityModal.module.scss";
import { ContactSupportModal } from "@/components";

export const ContactSupportCard = () => {
  const { t } = useI18nContext();
  const [, cn] = useModuleBEM(styles, "ChangeFlightEligibilityModal");

  return (
    <Card className={cn("policy-card")}>
      <h2 className={cn("policy-title")}>
        {t("selfServe.exchangeContactSupportTitle")}
      </h2>
      <p className={cn("policy-body")}>
        {t("selfServe.exchangeContactSupportBody")}
      </p>
      <ContactSupportModal
        trigger={
          <Button className={cn("contact-support-btn")}>
            {t("selfServe.exchangeContactSupportBtn")}
          </Button>
        }
      />
    </Card>
  );
};
